import React, { useState } from "react";
import UnderContruction from "../../components/under-construction/UnderContruction";
import { Container } from "react-bootstrap";
import "./about-page.css";

import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { Button, Card, Divider } from "@mui/material";
import PageHeader from "../../components/page-header/PageHeader";

const AboutPage = () => {
  const [pageStatus, setPagestatus] = useState(true);
  return (
    <div className="about-page">
      {pageStatus ? <AboutPageContent /> : <UnderContruction />}
    </div>
  );
};

const AboutPageContent = () => {
  return (
    <Container>
      <PageHeader title={"About me"} />
      <p className="about-page-summary">
        As a Fullstack Developer, I am passionate about creating cutting-edge
        software that delivers exceptional user experiences. With in-depth
        knowledge in the field, I have a good foundation in both front-end and
        back-end development, as well as expertise in a variety of programming
        languages and frameworks such as JavaScript, Python, Java, React.js,
        Node.js, Selenium etc.
      </p>
      <div className="about-page-banner"></div>

      <h3>Work Experience</h3>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color="green" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <h4>February 2023 - present</h4>
            <h5>Fullstack Developer - full time</h5>
            <h6>Cadabam's Group</h6>
            <ul>
              <li>
                Building full-stack solutions using React.js, Node.js, and APIs
                to enable the organization to provide their services to users
                and customers.
              </li>
              <li>
                Designing and developing web pages for the organization's
                website using Webflow.
              </li>
              <li>
                Implementing various automation workflows for marketing
                strategies using Node.js and webhooks.
              </li>
              <li>
                Writing JavaScript code to utilize JavaScript libraries in
                Webflow.
              </li>
              <li>
                Working with various APIs to integrate into business solutions
                including, Airtable API, Rasayel API
              </li>
            </ul>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color="green" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <h4>August 2021 - September 2021</h4>
            <h5> App Development Internship</h5>
            <h6>Nex-G Automation LLP</h6>
            {/* <ul>
              <li>
                Hands-on application of Android Studio and SDK for Android app
                development
              </li>
              <li>Practical implementation of app functionality using java</li>
              <li>
                Learnt to implement user interface in mobile apps using XML
              </li>
            </ul> */}
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color="green" />
            {/* <TimelineConnector /> */}
          </TimelineSeparator>
          <TimelineContent>
            <h4>Web Development Internship</h4>
            <h5>January 2021 - April 2021</h5>
            <h6>Gostoreless (Formerly Digital Belagavi)</h6>
            {/* <ul>
              <li>
                Designing low and high-fidelity wireframes and creating
                interactive prototypes.
              </li>
              <li>
                Implementing wireframes into real-world websites and web
                applications.
              </li>
              <li>
                Having hands-on experience in using Figma for designing website
                user interfaces and creating social media posts for the firm.
              </li>
            </ul> */}
          </TimelineContent>
        </TimelineItem>
      </Timeline>
      <div className="about-page-cta">
        <h2>Let's turn your ideas into reality</h2>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B919741120672&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            variant="contained"
            color="green"
            sx={{
              color: "white !important",
              borderRadius: "16px",
              textTransform: "capitalize",
              padding: "24px 40px",
              fontSize: "16px",
              fontWeight: "bold",
            }}
            size="large"
            disableElevation
          >
            Get in touch
          </Button>
        </a>
      </div>
    </Container>
  );
};

export default AboutPage;
